var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewEvent = function SvgNewEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1574_2989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4581 8.15991L20.2285 8.15991",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0108 8.16008H8.93834C4.70675 8.16008 1.27637 11.5905 1.27637 15.822L1.27637 58.7387C1.27637 62.9703 4.70675 66.4006 8.93834 66.4006H58.7412C62.9727 66.4006 66.4031 62.9703 66.4031 58.7387V15.822C66.4031 11.5905 62.9727 8.16008 58.7412 8.16008H55.6648",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7969 25.4097C39.1065 25.4097 38.5469 24.85 38.5469 24.1597C38.5469 23.4693 39.1065 22.9097 39.7969 22.9097V25.4097ZM39.7969 22.9097L65.2051 22.9097V25.4097L39.7969 25.4097V22.9097Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.883 22.9097C28.5733 22.9097 29.133 23.4693 29.133 24.1597C29.133 24.85 28.5733 25.4097 27.883 25.4097V22.9097ZM2.47168 22.9097L27.883 22.9097V25.4097L2.47168 25.4097V22.9097Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8398 24.1597H33.8369",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1182 14.5142C14.5136 14.5142 13.2129 13.2135 13.2129 11.6089L13.2129 4.1823C13.2129 2.5777 14.5136 1.27701 16.1182 1.27701C17.7228 1.27701 19.0235 2.5777 19.0235 4.1823V11.6089C19.0235 13.2135 17.7228 14.5142 16.1182 14.5142Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5615 14.5142C49.9569 14.5142 48.6562 13.2135 48.6562 11.6089V4.1823C48.6562 2.5777 49.9569 1.27701 51.5615 1.27701C53.1661 1.27701 54.4668 2.5777 54.4668 4.1823V11.6089C54.4668 13.2135 53.1661 14.5142 51.5615 14.5142Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3838 35.0178L37.9618 40.2416L43.7266 41.0793C45.1332 41.2836 45.6948 43.0123 44.677 44.0044L40.5056 48.0705L41.4903 53.8119C41.7306 55.213 40.2602 56.2812 39.0022 55.6197L33.846 52.909L28.6898 55.6197C27.4317 56.2812 25.9613 55.213 26.2016 53.8119L27.1863 48.0705L23.0149 44.0044C21.9971 43.0123 22.5587 41.2836 23.9653 41.0793L29.7301 40.2416L32.3081 35.0178C32.9372 33.7432 34.7547 33.7432 35.3838 35.0178Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1574_2989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
};
export default SvgNewEvent;